module.exports = __webpack_public_path__ + "img/fin_13_走向荒芜.785f43a1.jpg";